export default {
  ProjectBudgetConflictModal: () => import('./ProjectBudgetConflictModal/ProjectBudgetConflictModal.vue'),
  ProjectBudgetRepeatingModal: () => import('./ProjectBudgetRepeatingModal/ProjectBudgetRepeatingModal.vue'),
  ProjectBudgetSetEndDateModal: () => import('./ProjectBudgetSetEndDateModal/ProjectBudgetSetEndDateModal.vue'),
  ProjectBudgetDeleteBudgetModal: () => import('./ProjectBudgetDeleteBudgetModal/ProjectBudgetDeleteBudgetModal.vue'),
};
